import type { CartSuggestionCardsPreviewProduct } from './cart-suggestion-cards-block.config';
import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

/** Serializable product row used in CB2 cart recommendation preview scenarios. */
export type CartRecommendationCardsPreviewProduct = CartSuggestionCardsPreviewProduct;

/**
 * Serializable preview VM for `CartRecommendationCardsBlockComponent`.
 * Kept in content-builder so dashboard + webapp share the same transport shape.
 */
export type CartRecommendationCardsBlockScenarioContent = {
  /** Loaded recommendations; an empty array means the block is hidden. */
  recommendations: readonly CartRecommendationCardsPreviewProduct[];
};

export const CARTRECOMMENDATIONCARDSBLOCK_LEGACY_FIELD_ORDER = [
  "heading",
  "leading",
  "min_recommendations",
  "max_recommendations",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  cartRecommendationCardsBlockDescriptor: _generatedCartRecommendationCardsBlockDescriptor,
  cartRecommendationCardsBlockBlocDefinition,
  cartRecommendationCardsBlockDashboardLayout,
  cartRecommendationCardsBlockConfig,
  cartRecommendationCardsBlockResolveConfig,
  cartRecommendationCardsBlockProperties,
  cartRecommendationCardsBlockDefinitionSetupScenarios,
} = doodBlockConfig(
  {
    name: "Cart - Recommendation cards",
    componentType: 'CartRecommendationCardsBlockComponent',
    category: 'cart',
    description: "Cart - Recommendation cards.",
    keywords: [],
    allowedIn: [
      { bloc: 'CartPageComponent', slot: '*' },
    ],


    sharedFields: {}
  },

  () => ({
    heading: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.cart-recommendation-cards.heading.label",
      }
    }),
    leading: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.cart-recommendation-cards.leading.label",
      }
    }),
    min_recommendations: propertyValue({
      type: 'number',
      value: null,
      options: {
        label: "pages.blocks.cart-recommendation-cards.min-recommendations.label",
        help: "pages.blocks.cart-recommendation-cards.min-recommendations.help",
        min: 1,
        step: 1,
      },
    }),
    max_recommendations: propertyValue({
      type: 'number',
      value: null,
      options: {
        label: "pages.blocks.cart-recommendation-cards.max-recommendations.label",
        help: "pages.blocks.cart-recommendation-cards.max-recommendations.help",
        min: 1,
        step: 1,
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.cart-recommendation-cards.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.cart-recommendation-cards.fieldset.texts.label",
            fields: ["heading", "leading"],
          },
          {
            legend: "pages.blocks.cart-recommendation-cards.fieldset.recommendations.label",
            fields: ["min_recommendations", "max_recommendations"],
          },
        ],
      },
    ],
  })
);

export function cartRecommendationCardsBlockDescriptor(): IBlockDescriptor;
export function cartRecommendationCardsBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartRecommendationCardsBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartRecommendationCardsBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCartRecommendationCardsBlockDescriptor, cartRecommendationCardsBlockProperties, fieldOrder);
}

export {
  cartRecommendationCardsBlockBlocDefinition,
  cartRecommendationCardsBlockDashboardLayout,
  cartRecommendationCardsBlockProperties,
  cartRecommendationCardsBlockConfig,
  cartRecommendationCardsBlockResolveConfig,
  cartRecommendationCardsBlockDefinitionSetupScenarios,
};

export type CartRecommendationCardsBlockConfig = typeof cartRecommendationCardsBlockConfig;
